module.exports = __webpack_public_path__ + "media/workbench/canvas_background-33900075.png";